import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Grid,
  Typography,
  Slide,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton
} from '@mui/material';
import {
  Visibility,
  VisibilityOff
} from '@mui/icons-material';
import {
  contentBodySx,
  pageContainerSx
} from '../../../../common/styles/commonStyles';
const formControlSx = {
  '& .MuiOutlinedInput-root': {
    color: '#333',
    '& fieldset': {
      borderColor: '#BDBDBD'
    },
    '&:hover fieldset': {
      borderColor: '#DDAC5D'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#DDAC5D',
      borderWidth: 1
    }
  },
  '& .MuiInputLabel-root': {
    color: '#9E9E9E'
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: '#DDAC5D'
  }
};

const StepTwo = () => {
  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

  return (
    // <Slide in timeout={300} >
      <Box  sx={contentBodySx}>
        <Typography variant="formSubTitle">
          Step 2 - Medical Information &amp; Credentials
        </Typography>

        <Grid
          container
          spacing={3}
          sx={{
            width: '100%'
          }}
        >
          <Grid size={{ xs: 12, md: 4 }}>
            <FormControl fullWidth sx={formControlSx} variant="outlined">
              <InputLabel htmlFor="license">
                Medical License #
              </InputLabel>

              <OutlinedInput
                id="license"
                name="license"
                label="Medical License #"
              />
            </FormControl>
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <FormControl fullWidth sx={formControlSx} variant="outlined">
              <InputLabel htmlFor="npi">
                Individual NPI #
              </InputLabel>

              <OutlinedInput
                id="npi"
                name="npi"
                label="Individual NPI #"
              />
            </FormControl>
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <FormControl fullWidth sx={formControlSx} variant="outlined">
              <InputLabel htmlFor="dea">
                DEA #
              </InputLabel>

              <OutlinedInput
                id="dea"
                name="dea"
                label="DEA #"
              />
            </FormControl>
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <FormControl fullWidth sx={formControlSx} variant="outlined">
              <InputLabel htmlFor="uname">
                Username *
              </InputLabel>

              <OutlinedInput
                id="uname"
                name="uname"
                label="Username *"
              />
            </FormControl>
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <FormControl fullWidth sx={formControlSx} variant="outlined">
              <InputLabel htmlFor="password">
                Password *
              </InputLabel>

              <OutlinedInput
                id="password"
                name="password"
                label="Password *"
                type={showPassword ? 'text' : 'password'}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label={
                        showPassword
                          ? 'hide the password'
                          : 'display the password'
                      }
                      onClick={() => setShowPassword(show => !show)}
                      onMouseDown={event => event.preventDefault()}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <FormControl fullWidth sx={formControlSx} variant="outlined">
              <InputLabel htmlFor="confirmPassword">
                Confirm Password *
              </InputLabel>

              <OutlinedInput
                id="confirmPassword"
                name="confirmPassword"
                label="Confirm Password *"
                type={showConfirmPassword ? 'text' : 'password'}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label={
                        showConfirmPassword
                          ? 'hide the confirm password'
                          : 'display the confirm password'
                      }
                      onClick={() =>
                        setShowConfirmPassword(show => !show)
                      }
                      onMouseDown={event => event.preventDefault()}
                      edge="end"
                    >
                      {showConfirmPassword ? (
                        <VisibilityOff />
                      ) : (
                        <Visibility />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </Grid>
        </Grid>
      </Box>
    // </Slide>
  );
};

StepTwo.propTypes = {
  className: PropTypes.string
};

export default StepTwo;